import React from 'react';

import { useSelector } from 'react-redux';
import { Route, Routes } from 'react-router-dom';

import { navLinksData } from '../data/navLinks.jsx';
import PageNotFound from '../pages/PageNotFound/PageNotFound.jsx';
import CategoryList from '../pages/external/Service For you/CategoryList.jsx';
import Points from '../pages/external/Service For you/Points.jsx';
import ServiceFYUPRegistList from '../pages/external/Service For you/ServiceFYUPRegistList.jsx';
import ServiceForYouUPReg from '../pages/external/Service For you/ServiceForYouUPReg.jsx';
import { Changepassword } from '../pages/external/authentication/Changepassword.jsx';
import DonorLogin from '../pages/external/authentication/DonorLogin.jsx';
import DonorRegistration from '../pages/external/authentication/DonorRegistration.jsx';
import ForgotPassword from '../pages/external/authentication/ForgotPassword.jsx';
import OtpPage from '../pages/external/authentication/OtpPage.jsx';
import { UserActivate } from '../pages/external/authentication/UserActivate.jsx';
import PublicPortal from '../pages/external/portal/PublicPortal.jsx';
import EPUserProfile from '../pages/external/profile/EPUserProfile.jsx';
import APIdeaSuggestionList from '../pages/external/service/IdeaSuggestion/APIdeaSuggestionList.jsx';
import EPUserIdeaSuggestion from '../pages/external/service/IdeaSuggestion/EPUserIdeaSuggestion.jsx';
import Idea_Sugg_UP_RegistrationList from '../pages/external/service/IdeaSuggestion/Idea_Sugg_UP_RegistrationList.jsx';
import Idea_Sugg_Up_View from '../pages/external/service/IdeaSuggestion/Idea_Sugg_Up_View.jsx';
import CampaignList from '../pages/external/service/gwa/campaigns_Projects/CampaignList.jsx';
import ProjectList from '../pages/external/service/gwa/campaigns_Projects/ProjectList.jsx';
import GWAProjectList from '../pages/external/service/gwa/gwaProject/GWAProjectList.jsx';
import GWAProjectRegister from '../pages/external/service/gwa/gwaProject/GWAProjectRegister.jsx';
import GWAProjectView from '../pages/external/service/gwa/gwaProject/GWAProjectView.jsx';
import GWARegister from '../pages/external/service/gwa/gwaRegister/GWARegister.jsx';
import GWARegisterList from '../pages/external/service/gwa/gwaRegister/GWARegisterList.jsx';
import GWA_View from '../pages/external/service/gwa/gwaRegister/GWA_View.jsx';
import UpdateGWARegister from '../pages/external/service/gwa/gwaRegister/UpdateGWARegister.jsx';
import CreateServiceForDead from '../pages/external/service/sd/CreateServiceForDead.jsx';
import ServiceForDeadList from '../pages/external/service/sd/ServiceForDeadList.jsx';
import ServiceForDeadView from '../pages/external/service/sd/ServiceForDeadView.jsx';
import About from '../pages/external/static/About.jsx';
import AddCart from '../pages/external/static/AddCartPage.jsx';
import BoardofDirectors from '../pages/external/static/BoardofDirectors.jsx';
import { CampaignDonation } from '../pages/external/static/CampaignDonation.jsx';
import Contact from '../pages/external/static/Contact.jsx';
import Darmhamd from '../pages/external/static/Darmhamd.jsx';
import Executivemanagement from '../pages/external/static/Executivemanagement.jsx';
import Goodnessservices from '../pages/external/static/Goodnessservices.jsx';
import JudeGifts from '../pages/external/static/JudeGifts.jsx';
import Misionvision from '../pages/external/static/Misionvision.jsx';
import OurPolicyPdfView from '../pages/external/static/OurPolicyPdfView.jsx';
import Ouroffices from '../pages/external/static/Ouroffices.jsx';
import Physicaldonations from '../pages/external/static/Physicaldonations.jsx';
import RighteousnessDead from '../pages/external/static/RighteousnessDead.jsx';
import Services from '../pages/external/static/Services.jsx';
import Volunteer_us from '../pages/external/static/Volunteer_us.jsx';
import Youhavesame from '../pages/external/static/Youhavesame.jsx';
import Zakat from '../pages/external/static/Zakat.jsx';
import VolunteerDetailEdit from '../pages/external/volunteer/VolunteerDetailEdit.jsx';
import VolunteerEventSelection from '../pages/external/volunteer/VolunteerEventSelection.jsx';
import VolunteerRegistration from '../pages/external/volunteer/VolunteerRegistrationForm.jsx';
import Generaldonation from '../pages/general/Donation/Generaldonation.jsx';
import DownloadcenterDetail from '../pages/general/cms/PPDownloadcenter/DownloadcenterDetail.jsx';
import PublicPortalDownloadcenter from '../pages/general/cms/PPDownloadcenter/PublicPortalDownloadcenter.jsx';
import Infographic from '../pages/general/cms/infographic/Infographic.jsx';
import InfographicDetail from '../pages/general/cms/infographic/InfographicDetail.jsx';
import PhotoGallery from '../pages/general/cms/photoGallery/PhotoGallery.jsx';
import PhotoGalleryDetail from '../pages/general/cms/photoGallery/PhotoGalleryDetail.jsx';
import PressRelease from '../pages/general/cms/pressRelease/PressRelease.jsx';
import PressReleaseDetail from '../pages/general/cms/pressRelease/PressReleaseDetail.jsx';
import SuccessStory from '../pages/general/cms/successStory/SuccessStory.jsx';
import SuccessStoryDetail from '../pages/general/cms/successStory/SuccessStoryDetail.jsx';
import VideoGallery from '../pages/general/cms/videoGallery/VideoGallery.jsx';
import VideoGalleryDetail from '../pages/general/cms/videoGallery/VideoGalleryDetail.jsx';
import ExternalPayment from '../pages/general/payment/ExternalPayment.jsx';
import PaymentCertificate from '../pages/general/payment/PaymentCertificate.jsx';
import PaymentProcess from '../pages/general/payment/PaymentProcess.jsx';
import PaymentStatus from '../pages/general/payment/PaymentStatus.jsx';
import CampaignInfo from '../pages/general/refferrals/campaign/CampaignInfo.jsx';
import GWAProjectRefferal from '../pages/general/refferrals/project/gwa/GWAProjectRefferal.jsx';
import PublicProfile from '../pages/general/refferrals/publicProfile/PublicProfile.jsx';
import GWAProjectInfo from '../pages/general/services/gwa/GWAProjectInfo.jsx';
import AdminHomePage from '../pages/home/AdminHomePage.jsx';
import AdminLogs from '../pages/home/AdminLogs.jsx';
import Home from '../pages/home/Home.jsx';
import UserLogs from '../pages/home/UserLogs.jsx';
import UserPortalHomePage from '../pages/home/UserPortalHomePage.jsx';
import UserVerification from '../pages/home/UserVerification.jsx';
import CMSMenuList from '../pages/internal/ApplicationUserManagement/AccessRights/CMSMenu/CMSMenuList.jsx';
import ManagementLogin from '../pages/internal/ApplicationUserManagement/authentication/ManagementLogin.jsx';
import GetCampaignReportFilterList from '../pages/internal/Report/GetCampaignReportFilterList.jsx';
import GetEPUserProfileReport from '../pages/internal/Report/GetEPUserProfileReport.jsx';
import GetEPVolunteerReport from '../pages/internal/Report/GetEPVolunteerReport.jsx';
import GetGWAReportFilterList from '../pages/internal/Report/GetGWAReportFilterList.jsx';
import GetGWAServiceReportFilterList from '../pages/internal/Report/GetGWAServiceReportFilterList.jsx';
import GetSDReportFilterList from '../pages/internal/Report/GetSDReportFilterList.jsx';
import GetServiceForYouReportFilterList from '../pages/internal/Report/GetServiceForYouReportFilterList.jsx';
import LoginLogsReportList from '../pages/internal/Report/LoginLogReportList.jsx';
import PaymentReport from '../pages/internal/Report/PaymentReport.jsx';
import ReportList from '../pages/internal/Report/ReportList.jsx';
import AddGiftService from '../pages/internal/Service for Gift/AddGiftService.jsx';
import CertificateTemplate from '../pages/internal/Service for Gift/CertificateTemplate.jsx';
import GiftPayment from '../pages/internal/Service for Gift/GiftPayment.jsx';
import GiftServiceList from '../pages/internal/Service for Gift/GiftServiceList.jsx';
import ViewCertificate from '../pages/internal/Service for Gift/ViewCertificate.jsx';
import ViewGiftLogs from '../pages/internal/Service for Gift/ViewGiftLogs.jsx';
import GWAManageList from '../pages/internal/gwa/GWAManageList.jsx';
import GWAProjectApproval from '../pages/internal/gwa/gwaProjectApproval/GWAProjectApproval.jsx';
import GWAProjectApprovalList from '../pages/internal/gwa/gwaProjectApproval/GWAProjectApprovalList.jsx';
import GWARegisterApproval from '../pages/internal/gwa/gwaRegisterApproval/GWARegisterApproval.jsx';
import GWARegisterApprovalList from '../pages/internal/gwa/gwaRegisterApproval/GWARegisterApprovalList.jsx';
import BannerDashboard from '../pages/internal/internalCMS/bannerForm/BannerDashboard.jsx';
import Downloadcenter from '../pages/internal/internalCMS/cmsDownloadCenter/Downloadcenter.jsx';
import ReadInfographic from '../pages/internal/internalCMS/cmsInfographic/read/ReadInfographic.jsx';
import ReadPhotoGallery from '../pages/internal/internalCMS/cmsPhotoGallery/read/ReadPhotoGallery.jsx';
import ReadPressRelease from '../pages/internal/internalCMS/cmsPressRelease/read/ReadPressRelease.jsx';
import ReadSuccessStory from '../pages/internal/internalCMS/cmsSuccessStory/read/ReadSuccessStory.jsx';
import ReadVideoGallery from '../pages/internal/internalCMS/cmsVideoGallery/read/ReadVideoGallery.jsx';
import SDManageList from '../pages/internal/sd/SDManageList/SDManageList.jsx';
import SDProjectApproval from '../pages/internal/sd/SDProjectApproval/SDProjectApproval.jsx';
import SDProjectApprovalList from '../pages/internal/sd/SDProjectApprovalList/SDProjectApprovalList.jsx';
import SDPublishProjectList from '../pages/internal/sd/SDPublishProjectList/SDPublishProjectList.jsx';
import SDReport from '../pages/internal/sd/SDReports/SDReport.jsx';
import SDReportList from '../pages/internal/sd/SDReports/SDReportList.jsx';
import PrivateRoutes from '../utils/PrivateRoutes.jsx';
import SponsorDonation from '../pages/external/portal/SponsorDonation.jsx';
import ProjectDonation from '../pages/external/portal/ProjectDonation.jsx';
import SadaqatDonation from '../pages/external/portal/SadaqatDonation.jsx';
import PermanentCampaigns from '../pages/external/static/PermanentCampaigns.jsx';
import EmergencyCampaigns from '../pages/external/static/EmergencyCampaigns.jsx';

export function AllRoutes() {
  const isActive = useSelector((state) => state.toggle.isActive);
  return (
    <Routes>
      <Route element={<PrivateRoutes />}>
        {navLinksData.flatMap((item) =>
          item.children.map((child, childIndex) => {
            return <Route key={childIndex} path={child.link} element={child.element} />;
          }),
        )}
      </Route>
      <Route path="/" element={<Home />} />
      <Route path="/smsmenulist" element={<CMSMenuList />} />
      {/* <Route path="/admin" element={<AdminHomePage />} /> */}
      {/* <Route path="/user" element={<UserPortalHomePage />} /> */}
      <Route path="/managementLogin" element={<ManagementLogin />} />
      <Route path="/donorRegisteration" element={<DonorRegistration />} />
      <Route path="/activate/:activeGUID" element={<UserActivate />} />
      <Route path="/donorLogin" element={<DonorLogin />} />
      <Route path="/forgotpassword" element={<ForgotPassword />} />
      <Route path="/changepassword/:forgetGUID" element={<Changepassword />} />
      <Route path="/otp" element={<OtpPage />} />
      <Route path="/add-cart" element={<AddCart />} />
      {/* Static Routes for public Portal top menu */}
      <Route path="/about" element={<About isActive={isActive} />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/services" element={<Services />} />
      {/* <Route path="/OurPolicy" element={<Ourpolicy />} /> */}
      <Route path="/boardofDirectors" element={<BoardofDirectors />} />
      <Route path="/misionvision" element={<Misionvision />} />
      <Route path="/Ouroffices" element={<Ouroffices />} />
      <Route path="/Ourpolicy" element={<OurPolicyPdfView />} />
      <Route path="/executivemanagement" element={<Executivemanagement />} />
      <Route path="/darmhamd" element={<Darmhamd />} />
      <Route path="/Goodnessservices" element={<Goodnessservices />} />
      <Route path="/righteousnessDead" element={<RighteousnessDead />} />
      <Route path="/VolunteerWithus" element={<Volunteer_us />} />
      <Route path="/Youhavesame" element={<Youhavesame />} />
      <Route path="/Physicaldonations" element={<Physicaldonations />} />
      <Route path="/JudeGifts" element={<JudeGifts />} />
      <Route path="/Zakat" element={<Zakat />} />

      {/*General PORTAL*/}
      <Route path="/externalPayment/:id/:refferalLink/:pid/:projectTypeIdInt" element={<ExternalPayment />} />
      <Route path="/PaymentStatus" element={<PaymentStatus />} />
      <Route path="/CategoryList" element={<CategoryList />} />
      {/*CMS*/}
      <Route path="/publicPortalDownloadcenter" element={<PublicPortalDownloadcenter />} />
      <Route path="/PressRelease" element={<PressRelease />} />
      <Route path="/user/PressRelease" element={<PressRelease />} />
      <Route path="/downloadcenterdetail/:id" element={<DownloadcenterDetail />} />
      <Route path="/PressReleaseDetail/:id" element={<PressReleaseDetail />} />
      <Route path="/PhotoGallery" element={<PhotoGallery />} />
      <Route path="/user/PhotoGallery" element={<PhotoGallery />} />
      <Route path="/PhotoGalleryDetail/:id" element={<PhotoGalleryDetail />} />
      <Route path="/Infographic" element={<Infographic />} />
      <Route path="/InfographicDetail/:id" element={<InfographicDetail />} />
      <Route path="/SuccessStory" element={<SuccessStory />} />
      <Route path="/SuccessStoryDetail/:id" element={<SuccessStoryDetail />} />
      <Route path="/VideoGallery" element={<VideoGallery />} />
      <Route path="/user/VideoGallery" element={<VideoGallery />} />
      <Route path="/VideoGalleryDetail/:id" element={<VideoGalleryDetail />} />
      {/* <Route path="/:param1/:param2/:id" element={<PublicPortal />} /> */}
      <Route path="/user/DonationUser/SponsorshipsDonation/:id" element={<SponsorDonation />} />
      <Route path="/DonationUser/SponsorshipsDonation/:id" element={<SponsorDonation />} />
      <Route path="/user/DonationUser/SponsorshipsDonation/:id" element={<SponsorDonation />} />
      <Route path="/DonationUser/ProjectDonation/:id" element={<ProjectDonation />} />
      <Route path="/user/DonationUser/ProjectDonation/:id" element={<ProjectDonation />} />
      <Route path="/DonationUser/SadaqatDonation/:id" element={<SadaqatDonation />} />
      <Route path="/user/DonationUser/SadaqatDonation/:id" element={<SadaqatDonation />} />
      <Route path="/CampaignDonation/:id" element={<CampaignDonation />} />
      <Route path="/PermanentCampaigns/:id" element={<PermanentCampaigns />} />
      <Route path="/EmergencyCampaigns/:id" element={<EmergencyCampaigns />} />
      <Route path="/user/CampaignDonation/:id" element={<CampaignDonation />} />
      <Route path="/user/PermanentCampaigns/:id" element={<PermanentCampaigns />} />
      <Route path="/user/EmergencyCampaigns/:id" element={<EmergencyCampaigns />} />
      <Route path="/readPressRelease" element={<ReadPressRelease />} />
      {/* General Donation */}
      <Route path="/GeneralDonation" element={<Generaldonation />} />
      <Route path="/user/GeneralDonation" element={<Generaldonation />} />
      {/* CMS PHOTO GALLERY */}
      <Route path="/readPhotoGallery" element={<ReadPhotoGallery />} />
      {/* CMS INFOGRAPHIC */}
      <Route path="/readInfographic" element={<ReadInfographic />} />
      {/* CMS SUCCESS STORY */}
      <Route path="/readSuccessStory" element={<ReadSuccessStory />} />
      {/* CMS VIDEO GALLERY */}
      <Route path="/readVideoGallery" element={<ReadVideoGallery />} />
      {/* CMS DOWNLOAD CENTER */}
      <Route path="/downloadcenter" element={<Downloadcenter />} />
      {/* sliders dashboard  */}
      <Route path="/bannerDashboard" element={<BannerDashboard />} />

      {/*User Profile*/}
      {/*General Refferals*/}
      <Route path="/ProjectList/:referralLink/:pid" element={<ProjectList />} />
      <Route path="/PublicProfile/:referralLink/:pid" element={<PublicProfile />} />
      {/*Internal*/}
      <Route element={<PrivateRoutes />}>
        <Route path="/EPUserProfile/" element={<EPUserProfile />} />
        <Route path="/user" element={<UserPortalHomePage />} />
        <Route path="/verify/user/:id/:value/:isEmail" element={<UserVerification />} />
        <Route path="/user/logs" element={<UserLogs />} />
        <Route path="/admin" element={<AdminHomePage />} />
        <Route path="/admin/logs" element={<AdminLogs />} />

        {/*EPUserIdeaSuggestion*/}
        {/*External*/}
        <Route path="/EPUserIdeaSuggestion" element={<EPUserIdeaSuggestion />} />
        <Route path="/IdeaSuggUPRegistrationList" element={<Idea_Sugg_UP_RegistrationList />} />
        <Route path="/IdeaSuggUpView" element={<Idea_Sugg_Up_View />} />

        {/*External*/}
        <Route path="/IdeaSuggestionList" element={<APIdeaSuggestionList />} />
        {/* <Route path="/APIdeaSuggestionList" element={<APIdeaSuggestionList />} /> */}

        {/*External*/}
        <Route path="/EPUserProfile/:id" element={<EPUserProfile />} />

        {/* <Route path="/SDProjectInfo/:pId/:tId/:gId" element={<SDProjectInfo />} /> */}
        <Route path="/PaymentCertificate/:pId" element={<PaymentCertificate />} />

        {/*GWA Campaigns & Projects*/}
        <Route path="/CampaignList" element={<CampaignList />} />

        <Route path="/GWARegisterApproval/:id" element={<GWARegisterApproval />} />

        {/*GWA Services*/}

        {/*Internal*/}
        <Route path="/ServiceForDeadView" element={<ServiceForDeadView />} />
        <Route path="/GWAProjectApproval/:id" element={<GWAProjectApproval />} />
        <Route path="/GWARegisterApproval/:id" element={<GWARegisterApproval />} />
        <Route path="/GWARegisterApprovalList" element={<GWARegisterApprovalList />} />
        <Route path="/GWAProjectApprovalList" element={<GWAProjectApprovalList />} />
        <Route path="/ReportList" element={<ReportList />} />
        <Route path="/GWAProjectInfo/:id/:referralLink" element={<GWAProjectInfo />} />
        <Route path="/GWAManageList" element={<GWAManageList />} />

        {/*External*/}
        <Route path="/GWARegister" element={<GWARegister />} />
        <Route path="/ViewGWARegister" element={<UpdateGWARegister />} />
        <Route path="/GWARegisterList" element={<GWARegisterList />} />
        <Route path="/GWAProjectRegister" element={<GWAProjectRegister />} />
        <Route path="/GWAProjectList" element={<GWAProjectList />} />
        <Route path="/GWA_View/:id" element={<GWA_View />} />
        <Route path="/GWAProjectView" element={<GWAProjectView />} />
        <Route path="/VolunteerRegistration" element={<VolunteerRegistration />} />
        <Route path="/VolunteerEventSelection" element={<VolunteerEventSelection />} />
        <Route path="/VolunteerDetailEdit/" element={<VolunteerDetailEdit />} />

        {/*Service For Dead*/}

        {/*External*/}
        <Route path="/ServiceForDeadList" element={<ServiceForDeadList />} />
        <Route path="/CreateServiceForDead" element={<CreateServiceForDead />} />

        {/*Internal*/}
        <Route path="/SDProjectApproval/:id" element={<SDProjectApproval />} />
        <Route path="/SDProjectApprovalList" element={<SDProjectApprovalList />} />
        <Route path="/SDManageList" element={<SDManageList />} />
        <Route path="/SDPublishProjectList" element={<SDPublishProjectList />} />
        <Route path="/SDReportList" element={<SDReportList />} />
        <Route path="/SDReport/:id" element={<SDReport />} />

        {/*Service For you*/}
        <Route path="/ServiceForYouUPReg" element={<ServiceForYouUPReg />} />
        <Route path="/ServiceFYUPRegistList" element={<ServiceFYUPRegistList />} />
        <Route path="/Points" element={<Points />} />

        {/*Service For Gift*/}
        <Route path="/gifts" element={<GiftServiceList />} />
        <Route path="/add-gift/:id/:type" element={<AddGiftService />} />

        {/*PaymentProcess*/}
        {/* <Route path="/PaymentProcess/:pId/:tId/:gId" element={<PaymentProcess />} /> */}
        <Route path="/GWAProjectInfo/:id" element={<GWAProjectInfo />} />

        {/* report list */}
        <Route path="/GetSDReportFilterList" element={<GetSDReportFilterList />} />
        <Route path="/LoginLogsReportList" element={<LoginLogsReportList />} />
        <Route path="/GetGWAServiceReportFilterList" element={<GetGWAServiceReportFilterList />} />
        <Route path="/GetCampaignReportFilterList" element={<GetCampaignReportFilterList />} />
        <Route path="/GetServiceForYouReportFilterList" element={<GetServiceForYouReportFilterList />} />
        <Route path="/GetGWAReportFilterList" element={<GetGWAReportFilterList />} />
        <Route path="/EPVolunteerReportList" element={<GetEPVolunteerReport />} />
        <Route path="/EPUserReportList" element={<GetEPUserProfileReport />} />
        <Route path="/PaymentReport" element={<PaymentReport />} />
      </Route>
      <Route path="/PaymentProcess/:id/:refferalLink/:prossId/:projectTypeIdInt" element={<PaymentProcess />} />
      {/* <Route path="/PaymentProcess/:id/:refferalLink/:prossId" element={<PaymentProcess />} /> */}
      <Route path="/Gift" element={<GiftPayment />} />
      <Route path="/Gift/:giftLinkID" element={<ViewCertificate />} />
      <Route path="/Gift/giftLogs/:referralLink" element={<ViewGiftLogs />} />
      <Route path="/CampaignRefferral/:refferalLink/:pid" element={<CampaignInfo />} />
      <Route path="/GWAProjectRefferal/:referralLink/:id" element={<GWAProjectRefferal />} />
      <Route path="/certificateTemplate" element={<CertificateTemplate />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
}
